import { useContext } from 'react';

import Box from '@mui/material/Box';
import Fade from '@mui/material/Fade';

import ImageCoverPage from 'components/ImageCoverPage';

import { SchoolContext } from 'context/SchoolContext';

import Form from './components/Form';

function LoginCover() {
  const schoolContext = useContext(SchoolContext);

  return (
    <ImageCoverPage imgSrc={schoolContext?.loginImage}>
      <Fade in timeout={500}>
        <Box>
          <Form />
        </Box>
      </Fade>
    </ImageCoverPage>
  );
}

export default LoginCover;
